// Force unregister any existing service workers (one-time cleanup)
// https://onim.teamwork.com/app/tasks/26545109

const SW_CLEANUP_KEY = 'sw-cleanup-complete';
const SW_CLEANUP_VERSION = '1.0'; // Increment if you need to re-run cleanup

if ('serviceWorker' in navigator) {
	const cleanupVersion = localStorage.getItem(SW_CLEANUP_KEY);

	// Only run if not already completed for this version
	if (cleanupVersion !== SW_CLEANUP_VERSION) {
		const cleanupServiceWorkers = async () => {
			try {
				console.log('[SW Cleanup] Starting service worker cleanup...');

				// Try multiple approaches to find service workers
				let registrations = await navigator.serviceWorker.getRegistrations();

				// If no registrations found but controller exists, try ready
				const currentSW = navigator.serviceWorker.controller;
				if (registrations.length === 0 && currentSW) {
					const readyReg = await navigator.serviceWorker.ready;
					registrations = [readyReg];
				}

				// Also try to get registration by scope directly
				try {
					const scopeReg = await navigator.serviceWorker.getRegistration('/');
					if (scopeReg && !registrations.includes(scopeReg)) {
						registrations.push(scopeReg);
					}
				} catch (e) {
					// No registration at root scope
				}

				let unregisteredCount = 0;

				// Unregister all service workers
				for (const registration of registrations) {
					const success = await registration.unregister();
					if (success) {
						console.log(
							'[SW Cleanup] Service worker unregistered:',
							registration.scope
						);
						unregisteredCount++;
					}
				}

				// Clear all caches
				let clearedCacheCount = 0;
				if ('caches' in window) {
					const cacheNames = await caches.keys();
					await Promise.all(
						cacheNames.map(async cacheName => {
							const deleted = await caches.delete(cacheName);
							if (deleted) {
								clearedCacheCount++;
							}
						})
					);
				}

				// Mark cleanup as complete
				localStorage.setItem(SW_CLEANUP_KEY, SW_CLEANUP_VERSION);

				console.log(
					`[SW Cleanup] Complete - Unregistered: ${unregisteredCount}, Caches cleared: ${clearedCacheCount}`
				);

				// Only reload if we actually cleaned something up
				if (unregisteredCount > 0 || clearedCacheCount > 0) {
					console.log('[SW Cleanup] Reloading to apply changes...');
					setTimeout(() => window.location.reload(), 100);
				}
			} catch (error) {
				console.error('[SW Cleanup] Error during cleanup:', error);
				// Don't mark as complete if there was an error
			}
		};

		cleanupServiceWorkers().then(r => console.log('Cleanup complete'));
	} else {
		console.log('[SW Cleanup] Already completed for this version');
	}
}
